import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SiteContentProvider } from "./context/SiteContentContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import { CompareProvider } from "./context/CompareContext";
import { CampaignProvider } from "./context/CampaignContext";
import { CelebrationProvider } from "./context/CelebrationContext";
import { ProductLaunchProvider } from "./context/ProductLaunchContext";
import { AccentColorProvider } from "./context/AccentColorContext";
import { WikiProvider } from "./context/WikiContext";
import { LegalProvider } from "./context/LegalContext";
import { FaqProvider } from "./context/FaqContext";
import { BadgeVisibilityProvider } from "./context/BadgeVisibilityContext";
import { ProductCatalogProvider } from "./context/ProductCatalogContext";
import ScrollToTop from "./components/base/ScrollToTop";
import { SystemSettingsProvider } from "./context/SystemSettingsContext";

function InnerApp() {
  const { theme } = useTheme();
  return (
    <AccentColorProvider theme={theme}>
      <BadgeVisibilityProvider>
        <SiteContentProvider>
          <ProductCatalogProvider>
            <WikiProvider>
              <LegalProvider>
                <FaqProvider>
                  <ProductLaunchProvider>
                    <CelebrationProvider>
                      <CampaignProvider>
                        <CompareProvider>
                          <SystemSettingsProvider>
                            <BrowserRouter basename={__BASE_PATH__}>
                              <ScrollToTop />
                              <AppRoutes />
                            </BrowserRouter>
                          </SystemSettingsProvider>
                        </CompareProvider>
                      </CampaignProvider>
                    </CelebrationProvider>
                  </ProductLaunchProvider>
                </FaqProvider>
              </LegalProvider>
            </WikiProvider>
          </ProductCatalogProvider>
        </SiteContentProvider>
      </BadgeVisibilityProvider>
    </AccentColorProvider>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <InnerApp />
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
